
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M2.914 8.953h-.848a1 1 0 0 0-1 1v3.379a1 1 0 0 0 1 1h12.515a1 1 0 0 0 1-1V9.511"}}),_c('path',{attrs:{"stroke":"#798F8F","d":"M12.858 2.913 15 5.87a1.5 1.5 0 0 1-.334 2.095l-4.482 3.248c-.25.181-.55.28-.858.285l-1.656.023a1.5 1.5 0 0 1-1.236-.619L4.85 8.717a1.5 1.5 0 0 1 .334-2.095l5.579-4.043a1.5 1.5 0 0 1 2.095.335ZM6.807 5.279l3.903 5.384"}})])
          )
        }
      }
    